// extracted by mini-css-extract-plugin
export default {"commentsContainer":"MemberDetailsModal_commentsContainer__CKPuH","title":"MemberDetailsModal_title__n0kb9"};